import { useDucatClient } from "@/context/DucatClientCtx";
import { useQueryWalletBalance } from "./api/useQueryWalletBalance";

export const useWalletSats = () => {
  const { config, walletAddress, walletType } = useDucatClient();
  const { data: balance } = useQueryWalletBalance({
    esploraUrl: config.esploraUrl,
    address: walletAddress,
    ordUrl: config.ordUrl,
    walletType,
  });

  return balance?.sats_bal || 0;
};
